// 引入vue
import Vue from 'vue'
// 引入element-ui组件和样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 创建vue实例
let _this = new Vue();
// 引用ElementUI
Vue.use(ElementUI);
// 共用方法对象
let commonMethods = {
    /**
     * @function quickSort 快速排序方法
     * @param { Array } arr 
     */
    quickSort(arr) {
        if(arr.length <= 1) {
            return arr;
        }
        let flag = arr.shift();
        let left = [], right = [];
        for(let i = 0; i < arr.length; i++) {
            if(flag > arr[i]) {
                left.push(arr[i]);
            } else {
                right.push(arr[i]);
            }
        }
        return [...this.quickSort(left), flag, ...this.quickSort(right)];
    },
    /**
     * @function createTreeDom 创建树形组件元素方法
     * @param { Array } data 需要加载的数据
     * @param { * } dom 需要插入树形子元素的父节点
     * @param { boolean } check 是否显示复选框
     */
    createTreeDom(data, dom, check, copy) {
        var temp = [];
        let createDom = function (data, id) {
            if(data.length > 0) {
                for(let i = 0; i < data.length; i++) {
                    if(data[i].parent_id === id) {
                        temp += `<li class="tree-item">`;
                        temp += copy ? `<div class="item-box" id="${data[i].id}_cpid${data[i].parent_id}">` : 
                            `<div class="item-box" id="${data[i].id}_pid${data[i].parent_id}">`;
                        temp += `<div class="open-item">+</div>`;
                        if(check) {
                            temp += `<div class="check-box"></div>`;
                        }
                        temp += copy ? `<div class="copy-item-name">${data[i].name}</div>` : 
                            `<div class="item-name">${data[i].name}</div>`;
                        temp += `</div>`;
                        if(data[i].children) {
                            temp += copy ? `<div class="item-child" id="cpid${data[i].id}">` : 
                                `<div class="item-child" id="pid${data[i].id}">`;
                            temp += `<ul class="item-tree">`;
                            createDom(data[i].children, data[i].id);
                            temp += '</ul>';
                            temp += '</div>';
                        }
                        temp += '</li>';
                    }
                }
                return temp;
            }
        }
        createDom(data, 0);
        dom.innerHTML = temp;
    },
    /**
     * @function notificationShow 通知消息提醒
     * @param { string } title 标题
     * @param { string } msg 消息提醒内容
     * @param { string } 消息提醒组件偏移量(与顶部距离)
     */
    notificationShow(title, msg, offset) {
        _this.$notify({
            title: title,
            message: msg,
            offset: offset
        });
    },
    /**
     * @function goBack 返回上一页
     */
    goBack() {
        window.history.back();
    },
    /**
     * @function jointPicUrl 拼接图片路径
     * @param { string } url 
     */
    jointPicUrl(url) {
        let isHttp = String(url).slice(0, 4);
        if(isHttp === 'http') {
            return url;
        }
        return 'https://cdn.bigbays.cn/' + url;
    },
    /**
     * @function beforeAvatarUpload 图片上传格式大小判断
     */
    beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG) {
            _this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return isJPG && isLt2M;
    },
    /**
     * @function beforeVideoUpload 视频上传格式大小判断
     */
    beforeVideoUpload(file) {
        let type_list = ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'];
        const isJPG = type_list.indexOf(file.type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 500;
        if (!isJPG) {
            _this.$message.error('上传的视频只能是 MP4/OGG/AVI 格式!');
        }
        if (!isLt2M) {
            _this.$message.error('上传的视频大小不能超过 100MB!');
        }
        return isJPG && isLt2M;
    },
};
export default commonMethods


// WEBPACK FOOTER //
// ./src/common/common-methods/commonMethods.js